import {
  Component,
  AfterContentInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  OnInit
} from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';

import { UIService, generateRandomIdentifier } from '../../ui.service';
import { DossierService } from '../dossier.service';
import { ConfirmationService, SelectItem } from 'primeng-lts/api';

import {
  AwardDTO,
  ProcurementProjectLotDTO,
  AwardLotDTO
} from '../../api/plyca-dtos-v2';
import { FormConfig } from '../../components/forms/form.objects';
import { Observable, of, throwError } from 'rxjs';
import {
  getSimpleIdentifierFromString,
  TenderDTO,
  I18nData,
  MasterDataDTO
} from '../../api/plyca-dtos';
import { Configuration } from '../../conf/app.constants';

import { formPlycaComponent } from '../../components/forms/formPlyca.component';

import * as lodash from 'lodash';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';

import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';

import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { finalize } from 'rxjs/operators';
import { AppConfiguration } from '../../conf/app.configuration';

export class AwardDeclaraNoAdjModel {
  dto: ProcurementProjectLotDTO;
  ui: { visibleFechaDesierto: boolean }
}


@Component({
  selector: 'awardDeclaraNoAdj',
  templateUrl: 'awardDeclaraNoAdj.template.html'
})
export class AwardDeclaraNoAdjComponent extends BaseFormComponent<ProcurementProjectLotDTO, AwardDeclaraNoAdjModel> implements OnInit, OnDestroy {
  tagsParent: string[];
  private identifier: string;

  isFechaObligatoria: boolean;
  nonAwardResolutionReason: MasterDataDTO;
  nonAwardResolutionType: MasterDataDTO;



  procurementProjectLot: ProcurementProjectLotDTO;

  // referencia al formulario de edicion de datos
  formConfig: FormConfig;

  windowHash: string;
  constructor(
    public plycaService: PlycaDataService,
    public uiService: UIService,
    public dossierService: DossierService,
    public configuration: Configuration,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    public helpService: HelpService,
    protected appConfig: AppConfiguration,
    elem: ElementRef
  ) {
    super(elem);
    this.procurementProjectLot = dialogConfig.data;
    this.nonAwardResolutionReason = this.procurementProjectLot.nonAwardResolutionReason;
    this.nonAwardResolutionType = this.procurementProjectLot.nonAwardResolutionType;
    this.isFechaObligatoria = dialogConfig['isFechaObligatoria'];


  }

  initHeaderActions() {
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.EDIT_ADJUDICACION));
    this.windowHash = generateRandomIdentifier();
    this.headerActionsService.clearWindowActions(this.windowHash);

    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.save',
        'fas fa-lg fa-check',
        'btn-primary',
        true,
        this.windowHash
      ),
      success => {
        this.updateProcurementProjectLot(this.model.dto, true);
      });

  }

  updateProcurementProjectLot(dto: ProcurementProjectLotDTO, loaded: any) {
    let cliente = this.appConfig.getValue('cliente');

    if (cliente !== 'AYMAD' && !this.isFechaObligatoria && (!dto.nonAwardResolutionReason || !dto.nonAwardResolutionType)) {

      this.uiService.showMessage(
        new I18nData('AwardInfo.awardDeclaraNoAdj.msj'),
        new I18nData('General.info')
      );

    } else if (cliente !== 'AYMAD' && this.isFechaObligatoria && dto.rejectedDate === undefined) {
      this.uiService.showMessage(this.translateService.instant('AwardInfo.desertLotValidation'), 'General.info');
    } else if (cliente !== 'AYMAD' && (dto.textNonAwardResolutionReason === undefined || dto.textNonAwardResolutionReason.length === 0)
      && this.isFechaObligatoria) {
      this.uiService.showMessage(
        new I18nData('AwardInfo.awardDeclaraNoAdj.msjTexto'),
        new I18nData('General.info')
      );
    } else {
      dto.rejectedLot = true;
      this.subscribe(this.plycaService
        .updateProjectLotDesert(
          dto,
          dto.parent.identifier
        ),
        () => {
          console.log('EL LOTE SE HA MARCADO COMO NO RESUELTO ADJUDICACIÓN.');
          this.ref.close(dto);
        });
    }

  }

  getDataObservable(): ProcurementProjectLotDTO {
    return this.procurementProjectLot ? this.procurementProjectLot : undefined;
  }


  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {
        this.dialogConfig = null;
        this.dialogService = null;

      })));
  }

  getFormSettingURL(): string {
    return 'awardNoADJInterfaceSettings.json';
  }
  getServiceURL(operation?: string): string {
    return this.configuration.PROCUREMENTPROJLOT_SERVICE_ACTION;
  }
  getObjectIdentifier(): string {
    let identifier: string;
    identifier = undefined;
    return identifier;
  }

  dtoToModel(dto: ProcurementProjectLotDTO): Observable<AwardDeclaraNoAdjModel> {
    let model = new AwardDeclaraNoAdjModel();
    model.dto = dto;
    model.ui = {
      visibleFechaDesierto: false
    };

    model.ui.visibleFechaDesierto = this.isFechaObligatoria;
    let modelObs: Observable<AwardDeclaraNoAdjModel>;
    modelObs = of(model);
    return modelObs;
  }
  modelToDTO(model: AwardDeclaraNoAdjModel): ProcurementProjectLotDTO {
    let dto = model.dto;
    return dto;
  }
  getHeaderInfo(): import("../../tasks/baseFormComponent/baseForm.component").BaseFormHeaderInfo {
    let headerInfo: BaseFormHeaderInfo;
    if (!this.task) {
      headerInfo = new BaseFormHeaderInfo();

      headerInfo.title = 'Declarar la No adjudicación';
      headerInfo.titleIcon = 'fas fa-envelope-open-text';
    }
    return headerInfo;
  }


}
